import { Component, Vue } from 'vue-property-decorator';
import OrgInformation from './organization-information/OrganizationInformation.vue';
import OperationSetting from './operation-setting/OperationSetting.vue';

enum TabItem {
  OrgBasicInfo = 'Information',
  OperationSetting = 'Operation Settings'
}

@Component({
  components: { OrgInformation, OperationSetting }
})

export default class Organization extends Vue {
  private tab = 0;
  private readonly tabItems = [
    { title: TabItem.OrgBasicInfo, component: OrgInformation },
    { title: TabItem.OperationSetting, component: OperationSetting },
  ];

  mounted(): void {
    this.tab = parseInt(this.$route.params?.tab) ?? 0;
  }
}
